var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Manage Parked Domains "),
        _c(
          "div",
          {
            staticClass: "float-right"
          },
          [
            _c("gg-text-field", {
              attrs: {
                "append-icon": "mdi-magnify",
                placeholder: "Search",
                "hide-details": ""
              },
              model: {
                value: _vm.search,
                callback: function callback($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-data-table", {
                    attrs: {
                      search: _vm.search,
                      loading: _vm.loading,
                      headers: _vm.headers,
                      items: _vm.parkedDomains
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.actions",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "gg-btn",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("delete", item)
                                  }
                                }
                              },
                              [_vm._v(" Delete ")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("delete-alias-modal", {
                attrs: {
                  opened: _vm.modals.delete,
                  alias: _vm.selectedItem
                },
                on: {
                  "alias-removed": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("delete")
                  }
                }
              }),
              _c("manage-redirection-modal", {
                attrs: {
                  opened: _vm.modals.redirection,
                  "hosting-domain": _vm.selectedItem
                },
                on: {
                  "redirection-updated": _vm.reload,
                  "redirection-removed": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("redirection")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }